import React from 'react';
import ReactCountryFlag from 'react-country-flag';

// Maps both display names and 2-letter codes to ISO alpha-2
const TO_CODE = {
  Sverige: 'SE', Norge: 'NO', Finland: 'FI', Tyskland: 'DE', Danmark: 'DK', Nederländerna: 'NL',
  SE: 'SE', NO: 'NO', FI: 'FI', DE: 'DE', DK: 'DK', NL: 'NL',
};

/**
 * Renders a country flag SVG that works on all platforms (incl. Windows).
 * @param {string} market  – display name ('Sverige') OR code ('SE')
 * @param {string} size    – CSS size string, default '1.15em'
 */
export function MarketFlag({ market, size = '1.15em' }) {
  const code = TO_CODE[market];
  if (!code) return null;
  return (
    <ReactCountryFlag
      countryCode={code}
      svg
      style={{ width: size, height: size, verticalAlign: 'middle', flexShrink: 0 }}
      title={market}
    />
  );
}
